<style lang="stylus">
.container-modal {
  display: grid;
  background-color: #f2f2f2;
  justify-content: center;
  grid-row: 1fr;

  a {
    text-align: center;
    color: #8c1d40;
    text-decoration: underline;
    font-size: 12px;
    padding-bottom: 28px;
  }
}

.head-modal {
  background-color: #fec627;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.auditing-button {
  font-size: 18px;
  border: 2px solid #2a2a2a;
  border-radius: 100px;
  font-weight: bold;
  padding: 2.5px 16px;
  margin-bottom: 29px;
}

.fa-check-circle {
  font-size: 61px;
}

.fa-times-circle {
  font-size: 61px;
}

.timer-text {
  font-weight: bold;
  font-size: 16px;
  margin-left: 4px;
}

@media only screen and (max-width: 768px) {
  .head-modal {
    font-size: 18px !important;
    font-weight: bold;
  }

  .timer-text {
    font-size: 16px !important;
    font-weight: bold;
  }

  .container-modal {
    .v-btn__content {
      font-size: 16px !important;
    }

    .fa-check-circle {
      font-size: 40px !important;
    }

    .fa-times-circle {
      font-size: 40px !important;
    }
  }

  .deadline-timer {
    .fa-exclamation-triangle {
      padding: 0 2px 25px 17px;
    }
  }
}
</style>
<template>
  <v-dialog
    :modelValue="upgradeCourseDialog"
    max-width="720"
    @keydown.esc="closeUpgradeModal"
    @update:modelValue="$emit('update:upgradeCourseDialog', $event)"
  >
    <v-card>
      <v-card-title class="align-center justify-center"
        >Would you like to upgrade this course to the <br />credit-eligible track?
        <v-icon @click="closeUpgradeModal" style="position: absolute; right: 16px; top: 12px"
          >mdi-close</v-icon
        ></v-card-title
      >
      <v-card-title class="align-center justify-center"
        >Would you like to upgrade this<br />
        course to the credit-eligible track?
        <v-icon @click="closeUpgradeModal" style="position: absolute; right: 16px; top: 12px"
          >mdi-close</v-icon
        ></v-card-title
      >
      <v-row
        justify="center"
        style="padding-top: 27px"
        class="deadline-timer"
        v-if="!courseStartingInFuture && getTimeRemaining()"
      >
        <v-icon color="#fec627" style="font-size: 16px; margin-bottom: 15px">mdi-alert</v-icon>
        <p class="timer-text">{{ displayTimer }} remaining to upgrade.</p>
      </v-row>
      <v-container pt-0>
        <v-row wrap>
          <v-col cols="6" md="6">
            <v-card-text>
              <div class="container-modal">
                <v-icon color="#333333" style="padding: 37px 0">mdi-check-circle-outline</v-icon>
                <v-btn
                  @click="
                    upgradeCourseView();
                    asuoDataLayerClick('MyCourses', '0', {
                      region: courseSection,
                      section: title,
                      text: 'Upgrade this course',
                      type: 'internal link'
                    });
                  "
                  style="
                    background-color: #fec627;
                    font-weight: bold;
                    border-radius: 100px;
                    margin-bottom: 28px;
                    font-size: 18px;
                  "
                  :ripple="false"
                  variant="flat"
                  rounded
                  >Upgrade this course</v-btn
                >
                <a :href="howItWorks" target="_blank"
                  >Learn more about the benefits<br />
                  of upgrading</a
                >
              </div>
            </v-card-text>
          </v-col>
          <v-col cols="6" md="6">
            <v-card-text>
              <div class="container-modal">
                <v-icon color="#999999" style="padding: 37px 0 43px 0">mdi-close-circle-outline</v-icon>
                <button @click="auditCourse()" class="auditing-button">Preview this course</button>
                <a :href="courseBrief" target="_blank"
                  >Review the course brief to learn more<br />
                  about this course</a
                >
              </div>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';

import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { Helper } from '../mixins/helpers.js';
export default defineComponent({
  emits: ['update:upgradeCourseDialog', 'openCourse', 'upgradeCourseView', 'closeUpgradeModal'],

  data() {
    return {
      localArizonaTime: '',
      timer: '',
      displayTimer: '',
      howItWorks: 'https://ea.asu.edu/how-it-works/'
    };
  },

  mixins: [DataLayerMixin, Helper],

  props: {
    upgradeCourseDialog: { type: Boolean },
    courseStartingInFuture: { type: Boolean },
    deadlineCounter: { type: String },
    idVerificationDeadline: { type: String },
    courseBrief: { type: String },
    title: { type: String },
    courseSection: { type: String }
  },

  methods: {
    auditCourse() {
      this.$emit('openCourse');
    },

    upgradeCourseView() {
      this.$emit('upgradeCourseView');
    },

    closeUpgradeModal() {
      this.$emit('closeUpgradeModal');
    },

    getDaysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },

    correctZero(num) {
      return parseInt(num) < 10 ? '0' + num : num;
    },

    getTimeRemaining() {
      var deadline = new Date(this.idVerificationDeadline);
      deadline.setDate(deadline.getDate() + 1); //12 AM of next day of deadline

      if (deadline >= new Date()) {
        var t = Date.parse(deadline) - Date.parse(new Date());

        var minutes = Math.floor((t / 1000 / 60) % 60);
        var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));

        this.displayTimer = !(days || hours || minutes) ? '' : `${days} days ${hours} hours ${minutes} minutes`;

        return this.displayTimer;
      }
    }
  }
});
</script>
